import { OidcConfigurationModel } from './../models/oidcConfiguration.model';
import { AutomationAuthConfig } from '../models/automation-auth.model';
import { ConfigService } from './config.service';
import { LogPublisherConfig } from '../models/log-publisher-config.model';
import { Injectable, inject } from '@angular/core';


@Injectable()
/** Service to access App Settings based on configuration */
export class AppSettingsService {
    private readonly configService = inject(ConfigService);


    /* #region Public Methods */
    /** Property to get base api url from config */
    public get baseApiUrl(): string {
        return this.configService.getConfig('applicationServiceUrl');
    }

    /** Property to get environment name from config */
    public get environmentName(): string {
        return this.configService.getConfig('environmentName');
    }

    /** Property to get version from config */
    public get version(): string {
        return this.configService.getConfig('version');
    }

    /** Method to get logger config from config */
    public loggerConfiguration(): LogPublisherConfig[] {
        return this.configService.getConfig('logger-config');
    }
    /* #endregion */

    /** Method to get OIDC Configuration */
    public get oidcConfiguration(): OidcConfigurationModel {
        return this.configService.getConfig('oidcConfiguration');
    }

    /** Method to get toastrDisplayTime Configuration */
    public get toastrDisplayTime(): number {
        return 5000;
    }

    public get navNodeFileName(): string {
        return this.configService.getConfig('nav-nodes');
    }

    public get schedulerDashboardBaseUrl(): string {
        return this.configService.getConfig('schedulerDashboardBaseUrl');
    }


    public get automationAuthConfig(): AutomationAuthConfig {
        return this.configService.getConfig('automationAuth') || { enabled: false, allowedEncryptedUsers: [] };
    }

      public get supportEmail(): string {
        return this.configService.getConfig("supportEmail");
    }

    public get studyCodePatterns(): string[] {
        return this.configService.getConfig<string[]>('studyCodePatterns') ?? [];
    }
    
    /* #endregion */
}
